export default __webpack_public_path__ + "static/media/Quiken_Paqueteria_Local.64a9ac2f.png";